export const stat = {
  site_name: "Dream Store",
};
